import { render, staticRenderFns } from "./DtTeacher.vue?vue&type=template&id=4b7b021e&"
import script from "./DtTeacher.vue?vue&type=script&lang=js&"
export * from "./DtTeacher.vue?vue&type=script&lang=js&"
import style0 from "./DtTeacher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports